import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { ToastContainer } from "react-toastify";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./context/authContext";
import "react-toastify/dist/ReactToastify.css"; // Ensure Toastify styles are imported

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <App />
        <ToastContainer /> {/* ToastContainer placed inside the provider */}
      </AuthProvider>
    </BrowserRouter>
    <ToastContainer />
  </React.StrictMode>
);
